/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "status": {
                "nested": {
                  "Error": {
                    "fields": {
                      "field": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "message": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ValidationFinding": {
                    "fields": {
                      "fieldPath": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "validationErrorMessages": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "SanitizationResult": {
                    "fields": {
                      "fieldPath": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sanitizedValue": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ValidationStatus": {
                    "values": {
                      "VALIDATION_STATUS_UNSPECIFIED": 0,
                      "VALIDATION_STATUS_VALID": 1,
                      "VALIDATION_STATUS_INVALID": 2
                    }
                  },
                  "ValidationResult": {
                    "fields": {
                      "status": {
                        "type": ".squareup.onboard.activation.status.ValidationStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "findings": {
                        "type": ".squareup.onboard.activation.status.ValidationFinding",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "sanitizationResults": {
                        "type": ".squareup.onboard.activation.status.SanitizationResult",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "StatusResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "state": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "nativeClientErrorTitle": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "dataValidationResults": {
                        "type": ".squareup.onboard.activation.status.ValidationResult",
                        "id": 6,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.status?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.status?.nested?.ValidationFinding && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.status?.nested?.SanitizationResult && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.status?.nested?.ValidationStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.status?.nested?.ValidationResult && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.status?.nested?.StatusResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Error @ squareup/onboard/activation/status.proto at 4:1
 */
export const Error = $root.lookupType('squareup.onboard.activation.status.Error');
fixType(Error);
Builder.createAndAttachToType(Error);
/**
 * This mirrors squareup/validata/model.proto.
 * We cannot import that file here because it would create a circular dependency.
 *
 * SOURCE ValidationFinding @ squareup/onboard/activation/status.proto at 13:1
 */
export const ValidationFinding = $root.lookupType('squareup.onboard.activation.status.ValidationFinding');
fixType(ValidationFinding);
Builder.createAndAttachToType(ValidationFinding);
/**
 * SOURCE SanitizationResult @ squareup/onboard/activation/status.proto at 31:1
 */
export const SanitizationResult = $root.lookupType('squareup.onboard.activation.status.SanitizationResult');
fixType(SanitizationResult);
Builder.createAndAttachToType(SanitizationResult);
/**
 * SOURCE ValidationStatus @ squareup/onboard/activation/status.proto at 39:1
 */
export const ValidationStatus = $root.lookupEnum('squareup.onboard.activation.status.ValidationStatus').values;
/**
 * SOURCE ValidationResult @ squareup/onboard/activation/status.proto at 45:1
 */
export const ValidationResult = $root.lookupType('squareup.onboard.activation.status.ValidationResult');
fixType(ValidationResult);
Builder.createAndAttachToType(ValidationResult);
/**
 * SOURCE StatusResponse @ squareup/onboard/activation/status.proto at 58:1
 */
export const StatusResponse = $root.lookupType('squareup.onboard.activation.status.StatusResponse');
fixType(StatusResponse);
Builder.createAndAttachToType(StatusResponse);